export const ProfileStatusEnum = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
} as const

export type StatusProps = 'active' | 'inactive'

export interface ProfileStatusProps {
  status: StatusProps
}
